import { Component, OnInit, Input } from '@angular/core';
import * as moment from 'moment';


@Component({
    selector: 'app-nda-agreement',
    templateUrl: './nda-agreement.component.html'
})
export class NdaAgreementComponent implements OnInit {

    @Input() ndaDetails = {} as any;
    date = moment(new Date()).format('MM/DD/YYYY');

    constructor() { }

    ngOnInit() {

    }

}
